import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { Button, Modal } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import Loader from '../../pages/pages/loader'
import { useExecuteDistributionMutation } from '../../redux/apis/taskManagement/tMDistriputionApiSlice'

const DistributeTasks = ({ open, setOpen }) => {
  const [
    executeDistribution,
    { isLoading: isExecuting, isSuccess: successExecute, error: errorExecute }
  ] = useExecuteDistributionMutation()

  const handleDistribute = async () => {
    try {
      await executeDistribution({}).unwrap()
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    if (errorExecute?.data) {
      const errorMessages = Object.values(errorExecute.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [errorExecute])

  useEffect(() => {
    if (successExecute) {
      toast.success('Tasks distributed successfully!')
      setOpen(false)
    }
  }, [successExecute])

  return (
    <Modal
      className='customModal'
      open={open}
      title={
        <span>
          <ExclamationCircleOutlined
            style={{ color: '#faad14', marginRight: 8 }}
          />
          Confirm Distribution
        </span>
      }
      onCancel={() => setOpen(false)}
      footer={[
        <Button key='back' onClick={() => setOpen(false)}>
          Cancel
        </Button>,
        <Button
          key='submit'
          type='primary'
          danger
          onClick={handleDistribute}
          loading={isExecuting}
        >
          Distribute Tasks
        </Button>
      ]}
    >
      <Loader isLoading={isExecuting} />

      <div className='mb-3'>
        <p>
          Are you sure you want to distribute tasks to all assignees based on
          their current weights?
        </p>
        <p className='text-muted'>
          This action will assign pending tasks to users according to the
          configured distribution weights.
        </p>
      </div>
    </Modal>
  )
}

export default DistributeTasks
